<template>
  <div class="exchange-list">
    <ul class="clear fl">
      <li
        v-for="(item, index) in salesrooms"
        :key="index"
        class="list-content"
        @click="callBack('map', item)"
      >
        <div class="name-part">
          <div class="name"> {{ item.name }}</div>
          <div class="distance">{{ item.distance }}</div>
        </div>
        <div
          v-if="item.address"
          class="address-part common-font"
        >
          {{ item.address }}
        </div>
        <div class="common-font mar-5">{{ item.businessHours }}</div>
        <div
          v-if="item.mobile"
          class="common-font mar-5">
          {{ `${TLang('电话','brand')} ${item.mobile}` }}
        </div>
        <div
          v-if="item.serviceFee > 0"
          class="common-font mar-5 service"
        >
          <span>{{ TLang("需平台服务费", "brand") }}</span>
          <!-- <img :src="require('./imgs/tip.png')" alt="" /> -->
        </div>
        <div
          class="change-part"
          @click.stop="callBack('click', item)"
        >
          {{ TLang("去兑换", "brand") }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ExchangeList",

  props: {
    regions: {
      type: Array,
      default: () => [],
    },
    salesrooms: {
      type: Array,
      default: () => [],
    },
    callBack: Function,
  },

  computed: {},

  data() {
    return {};
  },

  mounted() {
    // this.isHasMoreArea();
  },

  methods: {
    // 地区是否显示展开收起
    // isHasMoreArea() {
    //   const { areaList, wrap } = this.$refs;
    //   const listHeight = areaList.offsetHeight;
    //   const itemHeight = areaList.children[0].offsetHeight + 12;
    //   this.hasMore = listHeight > itemHeight ? 1 : 0;
    //   wrap.style.height = `${itemHeight}px`;
    // },
    // 点击地区展开收起
    // setAreaListHeight() {
    //   const { areaList, wrap } = this.$refs;
    //   const listHeight = areaList.offsetHeight;
    //   const itemHeight = areaList.children[0].offsetHeight + 12;
    //   wrap.style.height =
    //     this.hasMore === 1 ? `${listHeight}px` : `${itemHeight}px`;
    //   this.hasMore = this.hasMore === 1 ? 2 : 1;
    // },
  },
};
</script>

<style lang="less" scoped>
.exchange-list {
  background: white;
  width: 100%;
  ul {
    width: 100%;
    li {
      padding: 15px 0 10px;
      border-bottom: 1px solid #ececec;
      width: 100%;
      position: relative;
    }
  }
  .name-part {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 14px;
      font-weight: 500;
      color: #000000;
    }
    .distance {
      font-size: 12px;
      font-weight: 400;
      color: #666666;
    }
  }
  .address-part {
    margin-top: 10px;
  }
  .business-part {
  }
  .common-font {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    max-width: 260px;
  }
  .mar-5 {
    margin-top: 5px;
  }
  .service {
    display: flex;
    align-items: center;
    img {
      width: 14px;
      height: 14px;
    }
  }
  .change-part {
    height: 26px;
    width: 60px;
    line-height: 26px;
    background: #3fa6ff;
    border-radius: 2px;
    font-size: 12px;
    color: white;
    text-align: center;
    position: absolute;
    bottom: 10px;
    right: 0;
  }
}
</style>
